import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table, Pagination, Button } from "react-bootstrap";
import Layout from "../../../layout/default";
import Swal from "sweetalert2";

const AssignVendor = () => {
  const [users, setUsers] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalUsers, setTotalUsers] = useState(0);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [showVendorList, setShowVendorList] = useState(false);

  useEffect(() => {
    // Fetch users data
    const fetchUsers = async () => {
      try {
        const authToken = localStorage.getItem("authToken");
        const response = await axios.get(
          `${process.env.REACT_APP_HOST}api/users/cold-state?page=${page + 1}`,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        setUsers(response.data.data.data);
        setTotalUsers(response.data.data.total);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
        Swal.fire("Error", "Failed to load data", "error");
      }
    };

    fetchUsers();
  }, [page]);

  const fetchVendors = async () => {
    try {
      const authToken = localStorage.getItem("authToken");
      const response = await axios.get(
        `${process.env.REACT_APP_HOST}api/vendors`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      setVendors(response.data);
    } catch (err) {
      Swal.fire("Error", "Failed to load vendors", "error");
    }
  };

  const handlePageChange = (newPage) => {
    setPage(newPage - 1);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleAssignClick = (user) => {
    setSelectedUser(user);
    setShowVendorList(true);
    fetchVendors();
  };

  const handleVendorSelect = (vendor) => {
    setSelectedVendor(vendor);
    Swal.fire(
      "Assigned!",
      `${selectedUser.first_name} ${selectedUser.last_name} has been assigned to ${vendor.business_name}.`,
      "success"
    );
    setShowVendorList(false);
    updateUserWithVendor(vendor);
  };

  const updateUserWithVendor = (vendor) => {
    setUsers((prevUsers) =>
      prevUsers.map((user) =>
        user.id === selectedUser.id ? { ...user, vendor: vendor } : user
      )
    );

    try {
      const authToken = localStorage.getItem("authToken");
      axios.post(
        `${process.env.REACT_APP_HOST}api/customer-vendors/${selectedUser.id}`,
        {
          vendor_id: vendor.id,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
    } catch (err) {
      Swal.fire("Error", "Failed to assign vendor to user", "error");
    }
  };

  const totalPages = Math.ceil(totalUsers / rowsPerPage);

  if (loading) return null;

  if (error) return <p>Error: {error}</p>;

  return (
    <Layout title="Assign Vendor">
      <div className="table-responsive">
        {!showVendorList && (
          <Table striped bordered hover>
            <thead className="thead-dark">
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Address</th>
                <th>Pincode</th>
                <th>Phone</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id}>
                  <td>{user.first_name} {user.last_name}</td>
                  <td>{user.email}</td>
                  <td>{user.address || "N/A"}</td>
                  <td>{user.pincode || "N/A"}</td>
                  <td>{user.phone_1}</td>
                  <td>
                    {user.vendor ? (
                      <span>{user.vendor.business_name}</span> // Display assigned vendor's name
                    ) : (
                      <Button
                        variant="primary"
                        onClick={() => handleAssignClick(user)}
                      >
                        Assign Vendor
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}

        {/* Display vendor list when assigning */}
        {showVendorList && (
          <div>
            <h4>Select a Vendor</h4>
            <Table striped bordered hover>
              <thead className="thead-dark">
                <tr>
                  <th>Business Name</th>
                  <th>Pincode</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {vendors.map((vendor) => (
                  <tr key={vendor.id}>
                    <td>{vendor.business_name}</td>
                    <td>{vendor.pincode}</td>
                    <td>
                      <Button
                        variant="success"
                        onClick={() => handleVendorSelect(vendor)}
                      >
                        Select
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </div>

      {/* Pagination */}
      <div className="d-flex justify-content-between align-items-center mt-3">
        <div>
          <label>
            Rows per page:{" "}
            <select
              value={rowsPerPage}
              onChange={handleRowsPerPageChange}
              className="form-select d-inline w-auto"
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={25}>25</option>
            </select>
          </label>
        </div>
        <Pagination>
          {[...Array(totalPages).keys()].map((pageNumber) => (
            <Pagination.Item
              key={pageNumber}
              active={pageNumber === page}
              onClick={() => handlePageChange(pageNumber + 1)}
            >
              {pageNumber + 1}
            </Pagination.Item>
          ))}
        </Pagination>
      </div>
    </Layout>
  );
};

export default AssignVendor;
